import cryptoJs from "crypto-js";

export const base64Decrypt = base64String => {
  const parsedWordArray = cryptoJs.enc.Base64.parse(base64String);
  const parsedStr = parsedWordArray.toString(cryptoJs.enc.Utf8);
  return parsedStr;
};
